module.exports = __webpack_public_path__ + "img/ezie_logo.74dbf7e8.png";